<template>
    <div class="card-header-right">
        <ul class="list-unstyled card-option" :style="{width:isOpen ? '230px': ''}">
          <li>
            <div><i class="icon-settings" :class="{'icon-angle-double-right': isOpen}" @click.prevent="disp()"></i></div>
          </li>
          <li><i class="view-html fa fa-code"></i></li>
          <li><i class="icofont icofont-maximize full-card"></i></li>
          <li><i class="icofont icofont-minus minimize-card"></i></li>
          <li><i class="icofont icofont-refresh reload-card"></i></li>
          <li><i class="icofont icofont-error close-card"></i></li>
        </ul>
      </div>
</template>
<script>
export default{
    name:'settingPage',
    data(){
            return{
            isOpen:false
        }},
        methods:
        {
            disp()
            {
                this.isOpen= !this.isOpen
            }
        }
}
</script>